module.exports = __webpack_public_path__ + "img/pptBg.80a3c2db.png";